import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import DefaultImage from "../../public/DefaultIcon.png";

const PartImageSlider = ({
  images = [],
  alt = "Part image",
  enableSlider = true,
}) => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (!enableSlider || !images || images.length <= 1) return;

    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [images, enableSlider]);

  if (!images || images.length === 0) {
    return (
      <img
        src={DefaultImage}
        alt="Fallback Part"
        className="absolute inset-0 w-full h-full object-cover"
      />
    );
  }

  // If slider is disabled, always show the first image (or handle error with default)
  if (!enableSlider || images.length === 1) {
    return (
      <img
        src={images[0]}
        alt={alt}
        className="absolute inset-0 w-full h-full object-cover"
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = DefaultImage;
        }}
      />
    );
  }

  return (
    <div className="absolute inset-0 w-full h-full overflow-hidden">
      <AnimatePresence initial={false}>
        <motion.img
          key={images[current]}
          src={images[current]}
          alt={`${alt} ${current + 1}`}
          className="absolute inset-0 w-full h-full object-cover"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = DefaultImage;
          }}
        />
      </AnimatePresence>
    </div>
  );
};

export default PartImageSlider;
